import { useNavigate } from "react-router-dom";


function SimpleAuthNavbar() {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate("/"); // Adjust this path if your landing page is different
  };

  return (
    <div className="d-flex align-items-center p-3"  >
      <div className="logo-badge me-2" style={{ cursor: "pointer" }} onClick={handleLogoClick}>
        <img
          src={`${process.env.PUBLIC_URL}/meetvana_logo.png`}
          alt="Logo"
          style={{ width: '40px', height: 'auto', objectFit: 'contain', borderRadius: '12px' }}
        />
      </div>
      <span className="brand-gradient fw-bold" style={{ cursor: "pointer" }} onClick={handleLogoClick}>eetvana</span>
    </div>
  );
}


export default SimpleAuthNavbar;